import { FC, useEffect } from 'react'
import Image from 'next/image'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { UseGetAdByPlacementCodeAndCurrentTime_AdFragment } from 'generated/graphql'
import {
  getCoverLetterSearchClickByPlatform,
  getCoverLetterSearchImpressionByPlatform,
} from '@app.feature/ad/modules/getEventNameByPlatform'
import { pushGTMCampaignId } from '@app.feature/ad/modules/gtmEvents'
import useIsWebview from '@app.modules/hooks/useIsWebview'
import useFlutterInappwebview from 'hooks/useFlutterInappwebview'
import { imageLoader, optimizeImageUrl } from 'utils/optimizeImageUrl'

interface IFProps {
  ad: UseGetAdByPlacementCodeAndCurrentTime_AdFragment
}

export const COVER_LETTER_SEARCH_BANNER_MOBILE_IMAGE_SIZE = {
  width: 330,
  height: 80,
}

const CoverLetterSearchBannerMobile: FC<IFProps> = ({ ad }) => {
  const router = useRouter()
  const isWebview = useIsWebview()
  const { fluterInappwebview } = useFlutterInappwebview()

  useEffect(() => {
    pushGTMCampaignId({
      eventName: getCoverLetterSearchImpressionByPlatform(isWebview),
      campaignId: ad.campaign?.id || '',
    })
  }, [router.query.id])

  const activityUrl = ad.activity?.id ? `/activity/${ad.activity?.id}` : ''

  const pushGtmBannerClickEvent = () => {
    pushGTMCampaignId({
      eventName: getCoverLetterSearchClickByPlatform(isWebview),
      campaignId: ad.campaign?.id || '',
    })
  }

  const navigateToLandingUrl = () => {
    if (!ad.campaign?.landingURL) {
      return
    }
    if (isWebview) {
      fluterInappwebview.callHandler(
        'requestOpenExternalBrowser',
        ad.campaign?.landingURL,
      )
    } else {
      window.open(ad.campaign?.landingURL, '_blank', 'noopener, noreferrer')
    }
  }

  const handleClickBanner = () => {
    pushGtmBannerClickEvent()
    if (activityUrl) {
      router.push(activityUrl)
    }
    navigateToLandingUrl()
  }

  const alt = ad?.campaign?.campaignGroup?.name
    ? `${ad?.campaign?.campaignGroup?.name} 자만검 배너 이미지`
    : `자만검 배너 이미지`

  return (
    <StyledWrapper
      onClick={handleClickBanner}
      aria-label="Advertisement"
      role="advertisement"
    >
      <Image
        layout="responsive"
        key="cover-letter-search-banner-image"
        className="cover-letter-search-banner-image"
        alt={alt}
        width={COVER_LETTER_SEARCH_BANNER_MOBILE_IMAGE_SIZE.width}
        height={COVER_LETTER_SEARCH_BANNER_MOBILE_IMAGE_SIZE.height}
        loader={imageLoader}
        src={optimizeImageUrl({
          url: ad.image?.url,
          width: COVER_LETTER_SEARCH_BANNER_MOBILE_IMAGE_SIZE.width,
          height: COVER_LETTER_SEARCH_BANNER_MOBILE_IMAGE_SIZE.height,
        })}
      />
    </StyledWrapper>
  )
}

export default CoverLetterSearchBannerMobile

const StyledWrapper = styled.div`
  .cover-letter-search-banner-image {
    border-radius: 5px;
  }
`
